import { put } from 'redux-saga/effects';
import { doSetFlashMessage } from '../actions';

export function* setFlashMessage(type, message) {
  const flashMessagePayload = {
    type,
    content: message,
  };

  yield put(doSetFlashMessage(flashMessagePayload));
}
